import Datepicker from 'flowbite/lib/esm/components/datepicker/index.js';

function initApiTokenExpiryDatepicker(section: Element): void {
    const input = section.querySelector<HTMLInputElement>('#api_token_expires');
    if (!input) {
        return;
    }
    const minDate = input.getAttribute('data-min-date') ?? undefined;
    new Datepicker(input, {
        autohide: true,
        format: 'yyyy-mm-dd',
        minDate,
        orientation: 'bottom right',
    });
}

function initCopyButton(section: Element): void {
    const copyButton = section.querySelector('[data-copy-api-token]');
    const tokenInput = section.querySelector('[data-api-token-plaintext]') as HTMLInputElement | null;
    if (!copyButton || !tokenInput) {
        return;
    }
    copyButton.addEventListener('click', async () => {
        try {
            await navigator.clipboard.writeText(tokenInput.value);
            copyButton.textContent = 'Copied';
            window.setTimeout(() => {
                copyButton.textContent = 'Copy token';
            }, 2000);
        } catch {
            tokenInput.select();
            document.execCommand('copy');
        }
    });
}

export function initProfileApiTokens(): void {
    const section = document.querySelector('[data-profile-api-tokens]');
    if (!section) {
        return;
    }
    initApiTokenExpiryDatepicker(section);
    initCopyButton(section);
}
